<template>
  <div class="spl-parcel-book-footer">
    <div class="row">
      <div class="col4">
        <form-label :dark="true">
          Send additional email to
        </form-label>
        <form-input
          v-model="email"
          :invalid="$v.email.$invalid"
          name="email"
          type="email"
          autocomplete="email"
          placeholder="Enter your email address here" />
        <span v-if="!$v.email.email" class="error">Please enter a valid E-Mail</span>
      </div>
      <!-- *********************** Create Documents  *********************************** -->
      <div v-if="userHasPermission(constants.PERMISSION_TYPES.CMR, constants.PERMISSION_VALUES.CREATE)" class="col5">
        <form-label
          v-if="(showCMR || showDeliveryNote)"
          :dark="true">
          Create transport document including
        </form-label>
        <div class="spl-checkbox-group">
          <div class="col4 spl-checkbox-group__item">
            <form-checkbox
              v-if="showCMR"
              v-model="cmr"
              :checked="!isForward && checkCMR"
              :is-checked="!isForward && checkCMR"
              @checkboxChanged="cmr_Set">
              CMR
            </form-checkbox>
          </div>
          <div class="col4 spl-checkbox-group__item">
            <form-checkbox
              v-if="showDeliveryNote"
              v-model="delivery_note"
              :checked="!isForward && checkDeliveryNote"
              :is-checked="!isForward && checkDeliveryNote"
              @checkboxChanged="delivery_Note_Set">
              Delivery note
            </form-checkbox>
          </div>
          <div class="col4 spl-checkbox-group__item">
            <form-checkbox
              v-if="bookingType === 'distributed'"
              v-model="loading_list"
              :checked="!isForward && bookingType === 'distributed' && checkLoadingList"
              :is-checked="!isForward && bookingType === 'distributed' && checkLoadingList"
              @checkboxChanged="loading_List_Set">
              Loadling list
            </form-checkbox>
          </div>
        </div>
      </div>
      <div class="col3">
        <form-button
          :extrapadding="true"
          :disabled="isBooking"
          class="spl-parcel-book-footer__save"
          @onClick="savedClicked">
          Save
        </form-button>
        <form-button
          :extrapadding="true"
          :secondary="true"
          @onClick="cancelClicked">
          Cancel
        </form-button>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
import { email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'ParcelBookFooter',
  props: ['bookingType', 'isBooking', 'isForward', 'bookingData'],
  data () {
    return {
      email: '',
      cmr: null,
      delivery_note: null,
      loading_list: null,
      constants,
      showDeliveryNote: true,
      showCMR: true,
      checkDeliveryNote: true,
      checkCMR: true,
      showLoadingList: true,
      checkLoadingList: true
    }
  },
  validations: {
    email: {
      email
    }
  },
  mounted () {
    this.$watch(vm => [vm.bookingData.book_parcel_model.Country_ID, vm.bookingData.book_parcel_model.Customer_ID, vm.bookingData.book_parcel_model.Is_Forward], val => {
      if (this.bookingData.book_parcel_model.Country_ID !== -1 && this.bookingData.book_parcel_model.Customer_ID !== -1) {
        this.getProfiler(this.bookingData.book_parcel_model.Customer_ID, this.bookingData.book_parcel_model.Country_ID, this.bookingData.book_parcel_model.Is_Forward)
      }
    },
    {
      immediate: true,
      deep: true
    })
  },
  methods: {
    ...mapActions('profiler', ['loadProfiler']),
    // Save button was clicked
    savedClicked () {
      // Emit the function and  pass the parameters (missing right now)
      var saveOptions = {
        Email: this.email,
        Create_CMR: this.cmr === null ? (!this.isForward && this.checkCMR) : this.cmr,
        Create_Delivery_Note: this.delivery_note == null ? (!this.isForward && this.checkDeliveryNote) : this.delivery_note,
        Create_Loading_List: (this.bookingType === 'distributed' && this.loading_list == null) ? !this.isForward : (this.loading_list === null ? false : this.loading_list)
      }
      this.$emit('saveClicked', saveOptions)
    },
    getProfiler (customer_id, country_id, is_forward) {
      var profileFilter = { Customer_ID: customer_id, Country_ID: country_id, Is_Forward: is_forward }
      this.loadProfiler(profileFilter).then(() => {
        this.profileData = JSON.parse(window.sessionStorage.getItem('Profiler_List'))
        if (this.profileData !== null && this.profileData.Fields.length > 0) {
          const found = this.profileData.Fields.find(el => el.Name === 'SEND ADDITIONAL EMAIL TO')
          const cmr = this.profileData.Fields.find(el => el.Name === 'CMR Checkbox')
          const deliveryNote = this.profileData.Fields.find(el => el.Name === 'Delivery Note Checkbox')
          const cmrDistributed = this.profileData.Fields.find(el => el.Name === 'CMR Checkbox Distributed')
          const deliveryNoteDistributed = this.profileData.Fields.find(el => el.Name === 'Delivery Note Checkbox Distributed')
          const loadingListDistributed = this.profileData.Fields.find(el => el.Name === 'Loadling list Checkbox Distributed')
          if (found && found.Default_Value !== '' && this.bookingType !== 'distributed') {
            this.email = found.Default_Value
          }
          if (cmr) {
            this.showCMR = cmr.Visible
            if (cmr.Default_Value !== '') {
              this.checkCMR = (cmr.Default_Value === 'true')
              this.cmr = !this.isForward && this.checkCMR
            }
          }
          if (deliveryNote) {
            this.showDeliveryNote = deliveryNote.Visible
            if (deliveryNote.Default_Value !== '') {
              this.checkDeliveryNote = (deliveryNote.Default_Value === 'true')
            }
          }
          if (cmrDistributed && this.bookingType === 'distributed') {
            this.showCMR = cmrDistributed.Visible
            if (cmrDistributed.Default_Value !== '') {
              this.checkCMR = (cmrDistributed.Default_Value === 'true')
            }
          }
          if (deliveryNoteDistributed && this.bookingType === 'distributed') {
            this.showDeliveryNote = deliveryNoteDistributed.Visible
            if (deliveryNoteDistributed.Default_Value !== '') {
              this.checkDeliveryNote = (deliveryNoteDistributed.Default_Value === 'true')
            }
          }
          if (loadingListDistributed && this.bookingType === 'distributed') {
            this.showLoadingList = loadingListDistributed.Visible
            if (loadingListDistributed.Default_Value !== '') {
              this.checkLoadingList = (loadingListDistributed.Default_Value === 'true')
            }
          }
        }
        this.$forceUpdate()
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    },
    cancelClicked () {
      this.$emit('cancelClicked')
    },
    cmr_Set (value) {
      this.cmr = value
    },
    delivery_Note_Set (value) {
      this.delivery_note = value
    },
    loading_List_Set (value) {
      this.loading_list = value
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-book-footer {
        background-color: $middleYellow;
        border-top: 3px solid #fff;
        padding: 45px $mainPadding 60px $mainPadding;
        width: 100%;
        position: fixed;
        bottom:0px;
        margin-left: -70px;
        .spl-input {
            margin-bottom: 0;
        }
        .spl-button {
            background-color: $mainInputColor;
            color: $footerButtonDarkGreyText;
            float: right;
            margin-bottom: 0;
            margin-top: 25px;
            &:focus, &:not([disabled]):hover {
              background-color: #fff;
              color: $yellowButtonLabelHover;
            }
            &-secondary {
                background-color: $footerButtonYellow;
                color: $yellowButtonLabel;
            }
        }
    }

    @include mobile() {
      .spl-parcel-book-footer {
        position: relative;
        margin: 0;
        padding: 20px 10px 30px 10px;
        .spl-label {
          margin-top: 15px;
        }
      }
    }
</style>
